import * as Ajax from '../ajax/Ajax';
/**
 * 組織オプション情報を取得します。
 *
 * @param fn ファンクション
 */

export function GetOrganizationOptions(fn) {
  Ajax.Post("InstallApi/GetOrganizationOptions", {}, Ajax.ModelResult(fn));
}